import React from 'react';
import { useDrop } from 'react-dnd';
import { ItemType } from './DraggableCode';

const ParentDropZone = ({ code, onDrop, children }) => {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: ItemType,
        drop: (item) => {
            if (item.id !== code.uuid && !code.parent) {
                onDrop(item.code, code.uuid); // Group under this parent
            }
        },
        canDrop: (item) => item.id !== code.uuid && !code.parent,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [code, onDrop]);

    return (
        <div
            ref={drop}
            className={
                isOver && canDrop
                    ? 'ring-4 ring-green-400 bg-green-50 rounded-lg p-2 transform scale-105 transition-all duration-200 shadow-lg'
                    : canDrop
                    ? 'ring-2 ring-gray-200 ring-opacity-50 rounded-lg transition-all duration-200'
                    : ''
            }
        >
            {children}
        </div>
    );
};

export default ParentDropZone;